<template>
    <div ref="shareCardDom" v-loading="loading">
        <div class="img-qrcode-div">
            <div>
                <div style="text-align: center;">
                    <qrcodeComponents v-if="null !== shareUrl" :url="shareUrl" :width="qrcodeWidth" :height="qrcodeHeight" />
                </div>

                <div style="margin-top: 15px">
                    <div class="link-copy-part">
                        <span tkey="鏈接">{{i18n.tkey("lang_link")}}：</span><span>{{shareUrl}}</span>
                        <span>&nbsp;&nbsp;</span>
                        <shareIcon @click="copyShareUrl"><font-awesome-icon icon="fa-solid fa-copy" style="color: #909399" /></shareIcon>
                    </div>

                    <div v-if="linkType == '1' && null != shopUrl && '' != shopUrl" class="link-copy-part">
                        <span tkey="店鋪鏈接">{{i18n.tkey("lang_shop_url")}}：</span><span>{{shopUrl}}</span>
                        <span>&nbsp;&nbsp;</span>
                        <shareIcon @click="copyShopUrl"><font-awesome-icon icon="fa-solid fa-copy" style="color: #909399" /></shareIcon>
                    </div>
                </div>
            </div>
        </div>

        <ul class="share-content-ul content-part" v-show="showReceiveEmailInput === false">
           <li>
               <span tkey="分享內容">{{i18n.tkey("lang_share_content")}}：</span>
               <span
                   class="copy-content-btn"
                   @click="copyShareContent"
               >
                   <font-awesome-icon icon="fa-solid fa-copy" style="color: #909399" />
               </span>
           </li>

            <li>
<!--                <el-input v-model="shareContent" :placeholder="i18n.tkey('lang_share_content')" clearable />-->
                <div class="des-area-box-1">
                    <el-input
                        type="textarea"
                        v-model="shareContent"
                        :placeholder="i18n.tkey('lang_share_content')"
                        clearable
                    />
                </div>
            </li>

            <li class="icon-share-part">
                <span tkey="發送方式">{{i18n.tkey("lang_sending_method")}}：</span>
            </li>

            <li class="icons-part">
<!--                <shareIcon @click="copyShareUrl"><font-awesome-icon icon="fa-solid fa-copy" style="color: #909399" /></shareIcon>-->
                <shareIcon @click="copyShareWhatsappUrl"><font-awesome-icon icon="fa-brands fa-whatsapp" style="color: #909399" /></shareIcon>
                <shareIcon @click="facebookShare"><font-awesome-icon icon="fa-brands fa-square-facebook" style="color: #3c589b;" /></shareIcon>
                <shareIcon @click="pinteresShare"><font-awesome-icon icon="fa-brands fa-square-pinterest" style="color: #c7453c;" /></shareIcon>
                <shareIcon @click="stumbleuponShare"><font-awesome-icon icon="fa-brands fa-stumbleupon-circle" style="color: #ee4c2c;" /></shareIcon>
                <shareIcon @click="toggleSharePart"><font-awesome-icon icon="fa-regular fa-envelope" style="color: #79bbff" /></shareIcon>
            </li>
        </ul>

        <div class="content-part" v-show="showReceiveEmailInput === true">
            <div style="text-align: left; line-height: 2;">
                <span style="float: right; font-size: 2em; line-height: 1; cursor: pointer;" @click="toggleSharePart"><font-awesome-icon icon="fa-solid fa-xmark" style="color: #F56C6C;"/></span>
                <span tkey="請輸入接收分享的郵箱地址">{{i18n.tkey("lang_input_share_email_address")}}</span>
            </div>

            <el-input v-model="receiveEmail" :placeholder="i18n.tkey('lang_receive_email_address')" clearable />
            <el-button type="primary" @click="sendShareEmail" style="margin-top: 15px;" tkey="發送">{{i18n.tkey("lang_send")}}</el-button>
        </div>
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, toRef, computed, inject, onBeforeMount} from "vue";
    import util from "@/util/util"
    import api from "@/request/api"
    import { useShareinfo } from '@/stores/shareinfo'
    import { useUserinfo } from '@/stores/userinfo'
    import qrcodeComponents from "@/components/shopopee/common/qrcodeComponents"
    import shareIcon from "@/components/shopopee/common/shareIcon"
    import copy from "clipboard-copy"
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faCopy, faXmark } from '@fortawesome/free-solid-svg-icons'
    import { faSquareFacebook, faSquarePinterest, faStumbleuponCircle } from '@fortawesome/free-brands-svg-icons'
    import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
    import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
    import shareApi from "@/request/shareApi";
    import companyApi from "@/request/companyApi";
    import myUtil from "@/util/util";

    library.add(faSquareFacebook, faSquarePinterest, faStumbleuponCircle, faEnvelope, faCopy, faWhatsapp, faXmark)

    const props = defineProps(["url", "type", "companycode", "linkType"])

    const userInfoRef = toRef(useUserinfo())

    const i18n = inject("i18n")

    const { proxy } = getCurrentInstance()

    const cardSpan = ref(24)
    const qrcodeSpan = ref(24)

    const componentWidth = ref(375)
    const loading = ref(true)

    const cardObj = ref(null)

    const shareUrl = ref(null)
    const shareContent = ref("3DShopopee")
    const shareType = ref("")

    const shopUrl = ref(null)

    const qrcodeWidth = ref(150)
    const qrcodeHeight = ref(150)

    const receiveEmail = ref("")
    const showReceiveEmailInput = ref(false)

    const shareWhatsappUrl = ref(null)

    const companyObj = ref(null)

    function facebookShare(){
        const titleStr = userInfoRef.value.name
        const content = shareContent.value.trim()
        const metaArr = [
            'og:url', encodeURIComponent(shareUrl.value),
            'og:title', titleStr,
            'og:description', content,
            'og:image', `${proxy.$ShopopeeUrl}static/images/shopopee-logo.png`
        ]
        const metaParams = metaArr.toString()
        // console.log(metaParams)
        const shareStr = `${proxy.$ShopopeeUrl}/sharePage?mate=${encodeURIComponent(metaParams)}`
        window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(shareStr)+'&t='+encodeURIComponent(document.title),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');
    }

    function pinteresShare(){
        const titleStr = userInfoRef.value.name

        window.open('https://www.pinterest.com/pin/create/button/?url='+encodeURIComponent(shareUrl.value)+"&media="+encodeURIComponent(`${proxy.$ShopopeeUrl}static/images/shopopee-logo.png`)+'&description='+titleStr,'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');
    }

    function stumbleuponShare() {
        const imgstr = `${proxy.$ShopopeeUrl}static/images/shopopee-logo.png`

        const titleStr = userInfoRef.value.name

        window.open('https://www.stumbleupon.com/submit?url=' + encodeURIComponent(shareUrl) + '&title=' + titleStr + "&media=" + encodeURIComponent(imgstr), '_blank', 'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');

    }

    function fillWhatsAppUrl(){
        const text = `${shareContent.value} \n ${shareType.value}:${shareUrl.value}`
        shareWhatsappUrl.value = `https://api.whatsapp.com/send/?text=${encodeURI(text)}`
    }

    function copyShareUrl(){
        copy(shareUrl.value)
        util.alertSuccess(i18n.tkey("lang_copy_success"))
    }

    function copyShopUrl(){
      copy(shopUrl.value)
      util.alertSuccess(i18n.tkey("lang_copy_success"))
    }

    function copyShareContent(){
        copy(shareContent.value)
        util.alertSuccess(i18n.tkey("lang_copy_success"))
    }

    function copyShareWhatsappUrl() {
        fillWhatsAppUrl()

        location.href = shareWhatsappUrl.value
        // copy(shareWhatsappUrl.value)
        // util.alertSuccess("已將內容複製到剪貼板")
    }

    function toggleSharePart(){
        receiveEmail.value = ""
        showReceiveEmailInput.value = !showReceiveEmailInput.value
    }

    function sendShareEmail(){
        if (util.emailCheck(receiveEmail.value)){
            loading.value = true

            const request = shareApi.sendShopShareEmail
            const params = request.getParams()
            params.email = receiveEmail.value
            params.url = shareUrl.value
            params.content = shareContent.value
            params.userId = userInfoRef.value.id

            params.content = params.content.replaceAll("\n", "<br>")

            // let startIndex
            // let endIndex = 0
            //
            // startIndex = params.content.indexOf("http")
            //
            // if (-1 !== startIndex){
            //     endIndex = params.content.indexOf("<br>", startIndex)
            //     let url = params.content.substring(startIndex, endIndex)
            //     url = `<a href="url">${url}</a>`
            //     params.content = params.content.splice(0, startIndex) + url + params.content.splice(endIndex)
            // }

            params.content = changeSpecialCharacters(params.content)

            request.send(
                params,
                (res) => {
                    loading.value = false
                    if (res.code == 200){
                        util.alertSuccess(i18n.tkey("lang_share_success"))
                        toggleSharePart()
                    }else{
                        util.alertError(i18n.tkey("lang_request_error"))
                    }
                },
                () => {
                    loading.value = false
                    util.alertError(i18n.tkey("lang_request_error"))
                }
            )
        }else{
            util.alertError(i18n.tkey("lang_error_format_email"))
        }
    }

    function getIslandShopData(){
        const request = companyApi.queryCompany3DInfo
        const params = request.getParams()

        params.companycode = props.companycode

        request.send(params, (res) => {
            loading.value = false

            if (res.code == 200){
                if (null != res.detail){
                    companyObj.value = res.detail
                    fillCompanyInfo()
                }
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function fillCompanyInfo(){
        const obj = companyObj.value

       const islandUrl = `${proxy.$ThreeDShopopeePath}landShop/${obj.countryCode}/${obj.shopId}`
        //const islandUrl = `${proxy.$ThreeDShopopeePath}${obj.record15Id}/index/${obj.countryCode}/${obj.wa}/${obj.siojournal}`
        const cardUrl = myUtil.generateCardShareUrl(obj.memberworkId)

        shopUrl.value = islandUrl

        generateShareContent(obj, cardUrl)
    }

    function generateShareContent(obj, cardUrl){
        let companyname = obj.companyName2
        let name = obj.name

        if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh" || myUtil.isEmpty(companyname)){
            companyname = obj.companyName
        }

        let content = `Hi! 我是${companyname}的 ${name}, 我在 3D Shopopee 展覽城的 3D 直播未來商店已經開業了! 歡迎各界朋友光臨!

店鋪連結: ${shopUrl.value}
我的名片: ${cardUrl}

我的商店有:
- 我的視頻直播
- 立体獨立展覧室 觀賞我的產品
- 如果有興趣, 可以直接購買或詢問


如有問題, 請即時與我們聯絡!`

        shareContent.value = content
    }

    function changeSpecialCharacters(link, startIndex){
        if (null == startIndex){
            startIndex = 0
        }

        let endIndex = 0

        startIndex = link.indexOf("http", startIndex)

        if (-1 !== startIndex){
            endIndex = link.indexOf("<br>", startIndex)
            let url = link.substring(startIndex, endIndex)
            let length = url.length
            url = `<a href="${url}">${url}</a>`
            length = url.length - length
            link = link.substring(0, startIndex) + url + link.substring(endIndex)

            link = changeSpecialCharacters(link, endIndex + length)
        }

        return link

    }

    onBeforeMount(() => {
        if (null != props.type){
            shareType.value = i18n.tkey("lang_shop_text_1")
            shareContent.value = i18n.tkey("lang_island_share_content")

            if (props.type == "0"){
                shareType.value = i18n.tkey("lang_hall_1")
                shareContent.value = i18n.tkey("lang_mall_share_content")
            }else if(props.type == "1"){
                shareType.value = i18n.tkey("lang_market")
                shareContent.value = i18n.tkey("lang_island_share_content")
            }else if(props.type == "2"){

              shareType.value = i18n.tkey("lang_products")
              shareContent.value = i18n.tkey("lang_agent_share_content")
            }

        }

        if (null != props.url){
            shareUrl.value = props.url
        }
        if (props.type != "2"){

          getIslandShopData()
        }else{

          loading.value = false
        }

    })

    onMounted(() => {
        componentWidth.value = proxy.$refs.shareCardDom.offsetWidth

        if (componentWidth.value >= 768){
            cardSpan.value = 14
            qrcodeSpan.value = 10

            qrcodeWidth.value = 200
            qrcodeHeight.value = 200
        }

        // loading.value = false

    })
</script>

<style scoped>
    .img-qrcode-div {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
    }

    .card-img {
        margin-bottom: 10px;
        max-width: 425px;
        max-height: 275px;
        object-fit: scale-down;
    }

    .share-content-ul {
        margin: 0;
        list-style: none;
        text-align: left;
        padding-left: 0;
        line-height: 2;
    }

    .content-part {
        margin-top: 25px;
    }

    .icon-share-part {
        margin-top: 10px;
    }

    .icons-part {
        padding: 10px;
    }

    .copy-content-btn {
        font-size: 1.5em;
        cursor: pointer;
    }

    .link-copy-part {
        word-break:break-all;
        word-wrap:break-word;
    }


</style>
<style>
.des-area-box-1 textarea {
    min-height: 10em !important;
}
</style>